import {Injectable} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Observable} from 'rxjs';
import {AlertComponent} from '../components/alert/alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
  ) {
  }

  confirm(message: string): Observable<string> {
    const initialState = {
      message: message
    };
    this.bsModalRef = this.bsModalService.show(AlertComponent, {
      initialState,
      backdrop: 'static',
      keyboard: false,
      animated: false
    });
    return new Observable<string>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer: any) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string) => {
        observer.next(this.bsModalRef.content.answer);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }

}
